import * as webBase from '@gnyio/web-base';
import { TransactionWebBase } from '@gnyio/web-base';
export function createTransactionEx(params) {
    if (!params.secret)
        throw new Error('Secret needed');
    const keys = webBase.getKeys(params.secret);
    if (params.secondSecret) {
        const secondKeys = webBase.getKeys(params.secondSecret);
        return TransactionWebBase.create({
            keypair: keys.keypair,
            secondKeypair: secondKeys.keypair,
            type: params.type,
            fee: String(params.fee),
            message: params.message,
            args: params.args,
        });
    }
    return TransactionWebBase.create({
        keypair: keys.keypair,
        type: params.type,
        fee: String(params.fee),
        message: params.message,
        args: params.args,
    });
}
//# sourceMappingURL=transaction.js.map